<template>
  <div class="content content-home">
    <div class="content__inner">
      <div class="wrapper wrapper--medium">
        <UiHeadline theme="white" size="large" class="mb-2">
          {{ $t("home.headline") }}
        </UiHeadline>

        <div class="deposit-model-overview">
          <div
            class="deposit-model"
            v-for="(model, index) in depositModels"
            v-bind:key="index"
          >
            <div class="deposit-model__icon">
              <svg width="64" height="64">
                <use v-bind:xlink:href="'#' + model.icon" />
              </svg>
            </div>
            <span class="deposit-model__name">{{ model.name }}</span>
          </div>
        </div>

        <div class="wrapper wrapper--narrow wrapper--no-padding cta-text-home">
          <p>{{ $t("home.cta.text") }}</p>

          <UiButton
            class="boxshadow"
            theme="primary"
            size="large"
            :to="{ name: 'depotfinder' }"
          >
            {{ $t("home.cta.btn") }}
          </UiButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiHeadline from "./../components/Ui/Headline.vue";
import UiButton from "./../components/Ui/Button/index.vue";
export default {
  components: {
    UiHeadline,
    UiButton
  },
  data() {
    return {
      depositModels: {
        depotDirekt: this.$t("depositmodels.DepotDirekt"),
        depotKomfort: this.$t("depositmodels.DepotKomfort"),
        depotExklusiv: this.$t("depositmodels.DepotExklusiv"),
        depotFuture: this.$t("depositmodels.DepotFuture")
      }
    };
  },
  mounted() {
    this.$store.dispatch("resetDepositFinderState");
  }
};
</script>
